import { Route, Routes } from 'react-router-dom'
import InteracHistoryListPage from './InteracHistoryListPage'

const InteracHistoryRouter = () => {
  return (
    <Routes>
      <Route path="*" element={<InteracHistoryListPage />} />
    </Routes>
  )
}

export default InteracHistoryRouter
